import React, {useEffect, useState} from "react";
import {isNotificationFormValid} from "./NotificationFormValidator";
import {Modal} from "antd";
import useAppContext from "../../../hooks/useAppContext";
import useUserContext from "../../../hooks/useUserContext";
import NewNotificationForm from "../../forms/NewNotificationForm";
import useToast from "../../../hooks/useToast";
// import MessageCreationFlow from "../../messageCreationFlow/MessageCreationFlow";
import MessageCreationFlow from "../../messageCreationFlow/MessageCreationFlow";
import {FlowProps} from "../../../types/FlowProps";
import {SHIPMENT_FLOW_TRIGGER_IDS} from "../../../consts/SHIPMENT_FLOW_TRIGGER_IDS";
import {ToastSkin} from "../../../context/ToastContext";
import {CONFIRM_BUTTON_OPTIONS} from "../../messagePreview/recoveryButtonLabels/ConfirmButtonOptions";
import {OPT_OUT_BUTTON_OPTIONS} from "../../messagePreview/recoveryButtonLabels/OptOutButtonOptions";
import {FLOW_TRIGGER_IDS} from "../../../consts/flowTriggerIds";

interface NewNotificationModalProps {
    isOpen: boolean;
    onClose: () => void;
    flowId: number;
}

export interface FormValuesProps {
    title: string;
    language: string;
    content: string;
    isCoupon: boolean;
    isWithImage: boolean;
    imageUrl?: string;
    triggerDelay: number | null;
    isActive: boolean;
    distribution: number;
    requiresConsent: boolean;
    button1Text: string;
    button2Text: string;
    button1Url?: string;
}

export const DEFAULT_FORM_VALUES = {
    title: '',
    language: 'en-US',
    content: '',
    isCoupon: false,
    isWithImage: true,
    triggerDelay: null,
    isActive: false,
    distribution: 100,
    requiresConsent: false,
    button1Text: CONFIRM_BUTTON_OPTIONS['en-US'][0],
    button2Text: OPT_OUT_BUTTON_OPTIONS['en-US'][0]
}

const NewNotificationModal = ({
    isOpen,
    onClose,
    flowId,
}: NewNotificationModalProps) => {
    const [step, setStep] = useState(1);
    const [stepsDone, setStepsDone] = useState(0);
    const [formValues, setFormValues] = useState<FormValuesProps>(DEFAULT_FORM_VALUES);
    const [formErrors, setFormErrors] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const { data: { flows }, actions: { createNotification, loadFlows } } = useAppContext();
    const { selectedDomain } = useUserContext();
    const { showToast } = useToast();
    const flow: FlowProps | undefined = flows.data.find((flow: FlowProps) => flow.id === flowId);

    const onCloseModal = () => {
        setStepsDone(0);
        setStep(1);
        setFormValues(DEFAULT_FORM_VALUES);
        setFormErrors([]);
        setIsLoading(false);
        onClose();
    }

    const onCreateNewNotification = async () => {
        setIsLoading(true);
        const errors = isNotificationFormValid(formValues, flow?.flowTriggerId);
        if(errors?.length) {
            //TODO: Error handling;
            console.log("errors: ", errors);
        }
        if(selectedDomain && !errors.length) {
            try {
                const response = await createNotification(selectedDomain, flowId, formValues);
                // onCloseModal();
                setIsLoading(false);
                loadFlows();
                return true;
            } catch (error) {
                console.log("error: ", error);
                showToast({ text: errors?.length ? errors[0] : 'An unknown error occurred while saving your template', skin: ToastSkin.error});
            }
        } else {
            showToast({ text: errors?.length ? errors[0] : 'An unknown error occurred while saving your template', skin: ToastSkin.error});
        }
        setIsLoading(false);
        return false;
    }

    const onFormUpdate = (newFormValues: any) => {
        !formErrors.length && setFormErrors([]);
        setFormValues(newFormValues);
    }

    const getCtaLabelByTrigger = (triggerId: number): string => {
        if(triggerId === FLOW_TRIGGER_IDS.ON_PURCHASE) { // new order
            return 'View My Order'
        } else if(triggerId === FLOW_TRIGGER_IDS.ON_NEW_SIGNUP) { //new customer
            return 'Browse Products';
        } else if(triggerId === FLOW_TRIGGER_IDS.ON_SHIPPING_ACKNOWLEDGED) {
            return formValues.content.includes('{{tracking URL}}') ? 'Track Your Order' : 'View My Order';
        } else {
            return 'Shop Now';
        }
    }

    useEffect(() => {
        const flowTriggersWithNoImage = SHIPMENT_FLOW_TRIGGER_IDS;
        if(flow?.flowTriggerId && flowTriggersWithNoImage.includes(flow.flowTriggerId)) {
            setFormValues({ ...formValues, isWithImage: false });
        }
    }, [flow?.flowTriggerId]);

    useEffect(() => {
        if(flow?.flowTriggerId !== undefined && flow?.flowTriggerId !== FLOW_TRIGGER_IDS.ABANDONED_CHECKOUT_IDENTIFICATION) {
            setFormValues({ ...formValues, button1Text: getCtaLabelByTrigger(flow.flowTriggerId)})
        }
    }, [flow?.flowTriggerId, formValues.content]);

    return (
        <Modal
            open={isOpen}
            onOk={onCreateNewNotification}
            onCancel={onCloseModal}
            confirmLoading={isLoading}
            okButtonProps={{ style: { display: 'none' }}}
            cancelButtonProps={{ style: { display: 'none' }}}
            width={1024}
            destroyOnHidden={true}
        >
            {/*<NewNotificationForm onFormUpdate={onFormUpdate} formErrors={formErrors} isLoading={isLoading} />*/}
            {flow?.flowTriggerId && <MessageCreationFlow flowTriggerId={flow.flowTriggerId} onCreateNewNotification={onCreateNewNotification} isLoading={isLoading} formValues={formValues} onFormUpdate={onFormUpdate} onClose={onCloseModal} step={step} setStep={setStep} stepsDone={stepsDone} setStepsDone={setStepsDone} />}
        </Modal>
    );
}

export default NewNotificationModal;